import React, { Component } from 'react'

class PickerBox extends Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      value: this.props.value || 'N/A'
    }

    this.handleClick = this.handleClick.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      value: nextProps.value || 'N/A'
    })
  }

  handleClick (e) {
    this.props.onClick && this.props.onClick(e)
  }

  render () {
    return (
      <div className='select-monthpicker' onClick={this.handleClick}><i className='fa fa-calendar-alt' /><span>{this.state.value}</span></div>
    )
  }
}

export default PickerBox
